import { render, staticRenderFns } from "./settlementDetails.vue?vue&type=template&id=68fc03fc&scoped=true&"
import script from "./settlementDetails.vue?vue&type=script&lang=js&"
export * from "./settlementDetails.vue?vue&type=script&lang=js&"
import style0 from "./settlementDetails.vue?vue&type=style&index=0&id=68fc03fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc03fc",
  null
  
)

export default component.exports